import { useEffect, useState } from "react";
import {
  validateRequired,
  validateEmail,
  ErrorMessage,
} from "../../utlis/function.js";
import CommonLoader from "../common/CommonLoader.jsx";
import { Eye, EyeOff } from "lucide-react";
import { useEditor } from "@tiptap/react";

const AddStaffModal = ({
  onClose,
  title = "Add Staff",
  description = "Add a new staff member to the system.",
  onSave,
  isLoading,
  type,
initialValues
}) => {
  const [formData, setFormData] = useState({
    name: "",
    emailid: "",
    access: "",
    password: "",
  });
  const[showPassword, setShowPassword] = useState(false);

  const [errors, setErrors] = useState({});

  // Role options for dropdown
  const roleOptions = [
    { value: "", label: "Select Role" },
    // { value: "admin", label: "Admin" },
    { value: "editor", label: "Editor" },
    { value: 'viewer', label: 'Viewer' }
  ];

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  useEffect(()=>{
     if (initialValues) {
    setFormData(prev => ({
      ...prev,
      ...initialValues
    }));
  }
  },[initialValues])
  const validateFields = () => {
    const newErrors = {};

    // Validate name
    if (!validateRequired(formData.name)) {
      newErrors.name = "Name is required";
    } else if (formData.name.trim().length < 2) {
      newErrors.name = "Name must be at least 2 characters";
    }


    if(type==="AddStaff"){

      // Validate emailid
      if (!validateRequired(formData.emailid)) {
        newErrors.emailid = "Email is required";
      } else if (!validateEmail(formData.emailid)) {
        newErrors.emailid = "Please enter a valid email address";
      }
  
      // Validate password
      if (!validateRequired(formData.password)) {
        newErrors.password = "Password is required";
      } else if (formData.password.length < 6) {
        newErrors.password = "Password must be at least 6 characters";
      }
    }
    // Validate access (role)
    if (!validateRequired(formData.access)) {
      newErrors.access = "Please select a role";
    }


    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateFields()) return;

    await onSave(formData);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-[#000000b5] flex items-center justify-center z-50">
      <div className="bg-white rounded-[20px] max-w-[811px] w-full mx-4 relative shadow-[0_4px_31.9px_11px_rgba(255,255,255,0.25)] animate-fade-in">
        {isLoading && <CommonLoader fullScreen />}

        <div className="p-8">
          <div className="max-h-[80vh] overflow-y-auto">
            {/* Title */}
            <h2 className="text-[28px] font-semibold text-black mb-2">
              {title}
            </h2>

            {/* Description */}
     <p className="text-[16px] text-[#666666] mb-6">{description}</p>
            <form autoComplete="off">
            <div className="grid md:grid-cols-2 grid-cols-1 gap-3">
              {/* Name Field */}
              <div className="mb-5">
                <label className="block text-sm font-medium text-black mb-2">
                  Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter staff name"
                  value={formData.name}
                  onChange={(e) => handleInputChange("name", e.target.value)}
                  className={`w-full h-[48px] px-4 rounded-full border focus:outline-none transition-colors ${
                    errors.name ? "border-red-500" : "border-[#DADADA]"
                  }`}
                />
                <ErrorMessage message={errors.name} />
              </div>

              {/* Email ID Field */}
              {
                type === "AddStaff" &&
              <div className="mb-5">
                <label className="block text-sm font-medium text-black mb-2">
                  Email ID <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  placeholder="Enter email address"
                  autoComplete="off"
                  value={formData.emailid}
                  onChange={(e) => handleInputChange("emailid", e.target.value)}
                  className={`w-full h-[48px] px-4 rounded-full border focus:outline-none transition-colors ${
                    errors.emailid ? "border-red-500" : "border-[#DADADA]"
                  }`}
                />
                <ErrorMessage message={errors.emailid} />
              </div>
              }

              {/* Access (Role) Dropdown */}
              <div className="mb-5">
                <label className="block text-sm font-medium text-black mb-2">
                  Access <span className="text-red-500">*</span>
                </label>
                <select
                  value={formData.access}
                  placeholder="Select role"
                  onChange={(e) => handleInputChange("access", e.target.value)}
                  className={`w-full h-[48px] px-4 rounded-full border focus:outline-none transition-colors bg-white ${
                    errors.access ? "border-red-500" : "border-[#DADADA]"
                  }`}
                >
                  {roleOptions.map((option) => (
                    <option
                      key={option.value}
                      value={option.value}
                      disabled={option.value === ""}
                    >
                      {option.label}
                    </option>
                  ))}
                </select>
                <ErrorMessage message={errors.access} />
              </div>

              {/* Password Field */}
            { type === "AddStaff" && <div className="mb-8 relative">
                <label className="block text-sm font-medium text-black mb-2">
                  Password <span className="text-red-500">*</span>
                </label>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter password"
                  value={formData.password}
                  onChange={(e) =>
                    handleInputChange("password", e.target.value)
                  }
                  className={`w-full h-[48px] px-4 rounded-full border focus:outline-none transition-colors ${
                    errors.password ? "border-red-500" : "border-[#DADADA]"
                  }`}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-4 top-2/3 -translate-y-1/2 text-[#a0aec0] hover:text-[#06323A] transition-colors"
                >
                  {showPassword ? (
                    <EyeOff size={20} />
                  ) : (
                    <Eye size={20} />
                  )}
                </button>
                <ErrorMessage message={errors.password} />
              </div>}
            </div>
            </form>
          </div>

          {/* Buttons */}
          <div className="flex gap-6 justify-center mt-3">
            <button
              onClick={onClose}
              className="w-[255px] h-[52px] rounded-full border border-[#06323A] text-[#06323A] font-medium hover:bg-gray-50"
            >
              Cancel
            </button>

            <button
              onClick={handleSave}
              disabled={isLoading}
              className="w-[255px] h-[52px] rounded-full bg-[#0A3A44] text-white font-medium hover:opacity-90"
            >
              {isLoading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddStaffModal;
